// Tiny site-wide store for the active promo code — shared by Pricing, Buy and
// the PromoBanner so a code applied anywhere adjusts prices everywhere.
let active = null;
const listeners = new Set();

export const getPromo = () => active;

export const setPromo = (promo) => {
  active = promo;
  listeners.forEach((fn) => fn(active));
};

export const clearPromo = () => setPromo(null);

export const subscribePromo = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const promoText = (p) =>
  p?.percent_off ? `${p.percent_off}% off` : p?.amount_off ? `$${p.amount_off} off` : "";
